import React, { useState } from 'react';

import Avatar from '@/core/components/Avatar';
import RadioInput from '@/core/components/inputs/RadioInput';
import type { UserResult } from '@/core/types/users';

export interface TakerCardProps {
  taker: UserResult;
  checked?: boolean;
  onChange?: (value: string) => void;
  onBlur?: (value: string) => void;
}
const TakerCard: React.FC<TakerCardProps> = ({ taker, checked, onChange, onBlur }) => {
  const [localValue, setLocalValue] = useState<string>(taker.uuid);

  const handleChange = (value: string) => {
    setLocalValue(value);
    onChange?.(value);
    onBlur?.(value);
  };

  return (
    <div className={`${checked ? 'bg-bg-pale' : 'bg-bg-primary'} rounded-1 px-2 py-1 hover:bg-bg-pale`}>
      <RadioInput key={taker.uuid} id={`${taker.uuid}`} value={localValue} checked={checked} onChange={handleChange} onBlur={handleChange}>
        <span className="flex items-center gap-2">
          <Avatar avatarUrl={taker.avatar_url} size="48" />
          <span className="text-text-caption-primary font-semibold text-content-primary">{taker.username}</span>
        </span>
      </RadioInput>
    </div>
  );
};

export default TakerCard;
